import { DateFormats, formatDate } from '@strata/helper-functions';

import { type RequestDetails } from 'services/interfaces';

interface RequestSummarySectionProps {
    requestDetails: RequestDetails;
}

export const RequestSummarySection = ({ requestDetails }: RequestSummarySectionProps) => (
    <div className="sds_request-summary-section">
        <div className="sds_request-summary-section__title">
            {requestDetails.requestSubType ?? 'Other'}
        </div>
        <div className="sds_request-summary-section__details">
            {`Created on ${formatDate(requestDetails.createDate, DateFormats.DATE_TIME)} by ${
                requestDetails.submitterFullName
            }`}
        </div>
    </div>
);
